<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" style="margin-bottom:0px">
          <div class="">
            <el-tabs v-model="currentType" type="card">
              <!-- 视频列表 -->
              <el-tab-pane label="视频列表" name="video">
                <videos v-if="currentType == 'video'"></videos>
              </el-tab-pane>
              <!-- 视频列表 -->

              <!-- 草稿 -->
              <el-tab-pane label="草稿" name="draft">
                <draft v-if="currentType == 'draft'"></draft>
              </el-tab-pane>
              <!-- 草稿 -->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import videos from "./videos"; //视频列表
import draft from "./draft"; //草稿列表
import { addCache, updateCache } from "@/util/localAche.js";
/**
 * Tabs & accordions component
 */
export default {
  components: {
    Layout,
    videos,
    draft,
  },
  data() {
    return {
      title: "videoPublish",
      currentType: "",
      text: `
         Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.
        `,
      content: `Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus.`,
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("from", from);
    if (["/videoPublishDetail", "/videoComments"].indexOf(from.path) == -1) {
      console.log("清空视频列表缓存");
      //如果不是跳转到详情或评论页则清空缓存的列表数据
      updateCache("video-list", { list: "" });
      updateCache("video-first", { list: "" });
      updateCache("video-draft", { list: "" });
    }
    if (from && from.path != "/videoPublishDetail") {
      //如果不是从详情回到列表就清空编辑缓存id
      addCache("video-edit", "");
    }
    next();
  },

  beforeRouteLeave(to, from, next) {
    console.log("from", from);
    if (["/videoPublishDetail", "/videoComments"].indexOf(to.path) == -1) {
      console.log("清空视频列表缓存");
      //如果不是跳转到详情或评论页则清空列表数据
      updateCache("video-list", { list: "" });
      updateCache("video-first", { list: "" });
      updateCache("video-draft", { list: "" });
    }
    next();
  },
  created() {
    if (this.$route.query.type) {
      this.currentType = this.$route.query.type;
    } else {
      this.currentType = "video";
    }
  },

  watch: {
    currentType(newVal, oldVal) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.type = this.currentType;
      this.$router.push({ path: this.$route.path, query });
      //切换到其它tab时清空本tab缓存的列表数据
      if (oldVal) {
        addCache("video-edit", "");
        if (oldVal == "video") {
          this.updateCache("video-list", { list: "" }, 500);
        } else if (oldVal == "first") {
          this.updateCache("video-first", { list: "" }, 500);
        } else if (oldVal == "draft") {
          this.updateCache("video-draft", { list: "" }, 500);
        }
      }
    },
    $route() {
      if (this.currentType) {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        query.type = this.currentType;
        this.$router.push({ path: this.$route.path, query });
      }
    },
  },
};
</script>
